import { Users, UserCheck, Route, CalendarDays, Wallet, BadgeDollarSign, AlertTriangle, FileClock, Truck, Receipt, Bell, FileCheck, History, BarChart3, Settings, LayoutDashboard, Search, ChevronLeft, Plus } from "lucide-react";
import { TONES } from "@/pages/preview/themes";

const NAV = [[LayoutDashboard, "لوحة التحكم"], [Users, "ملفات السائقين"], [Truck, "الشاحنات"], [Route, "النقلات"], [Receipt, "الفواتير"], [AlertTriangle, "المخالفات"],
  [Bell, "الإشعارات"], [FileCheck, "المستندات"], [Wallet, "الرسوم والدفعات"], [History, "سجل النشاط"], [BarChart3, "التقارير"], [Settings, "الإعدادات"]];
const STATS = [[Users, "إجمالي السائقين", "24", "blue"], [UserCheck, "السائقون النشطون", "21", "green"], [Route, "نقلات اليوم", "13", "violet"], [CalendarDays, "نقلات الشهر", "318", "teal"],
  [BadgeDollarSign, "المبالغ المحصلة", "4,250.000 د.ك", "green"], [Wallet, "غير المدفوعة", "780.500 د.ك", "orange"], [AlertTriangle, "المخالفات", "7", "red"], [FileClock, "مستندات قريبة الانتهاء", "5", "amber"]];
const TRIPS = [["TRP-000318", "ونش", "محمد العنزي", "21", "45454", "25.000", "مدفوع", "green"], ["TRP-000317", "هاف لوري", "أحمد سالم", "34", "11872", "40.000", "جزئي", "amber"],
  ["TRP-000316", "ونش", "خالد المطيري", "21", "90021", "18.000", "غير مدفوع", "red"]];

export const IconBox = ({ t, tone, Icon, size = 48, iconSize = 22 }) => (
  <span className="inline-flex items-center justify-center shrink-0" style={{ width: size, height: size, ...t.icon(TONES[tone]) }}><Icon style={{ width: iconSize, height: iconSize }} strokeWidth={2} /></span>
);

export const Plate = ({ t, adm, plate }) => (
  <span className="inline-flex items-center gap-1 text-xs font-bold"><span className={`px-2 py-0.5 rounded-md ${t.badgeAdm}`}>{adm}</span><span className={`px-2 py-0.5 rounded-md ltr ${t.badgePlate}`}>{plate}</span></span>
);

function Sidebar({ t }) {
  return (
    <aside className={`hidden lg:flex w-64 flex-col p-4 gap-1 shrink-0 ${t.sidebar}`}>
      <div className="flex items-center gap-3 mb-5 px-2"><span className={`w-11 h-11 rounded-2xl flex items-center justify-center font-black ${t.logo}`}>AO</span>
        <div><div className="font-black text-white" style={{ fontFamily: "var(--pv-head)" }}>المحيط الأطلسي</div><div className="text-xs text-white/60">للنقليات ذ.م.م</div></div></div>
      {NAV.map(([I, l], i) => <div key={l} className={`flex items-center gap-3 px-3 py-2.5 rounded-xl text-sm font-bold transition-colors ${i === 0 ? t.navActive : t.navItem}`}><I className="w-5 h-5" />{l}</div>)}
    </aside>
  );
}

function StatCard({ t, s: [I, l, v, tone] }) {
  return (
    <div className={`p-4 transition-all duration-200 hover:-translate-y-0.5 cursor-pointer ${t.card}`}>
      <div className="flex items-start justify-between"><IconBox t={t} tone={tone} Icon={I} /><ChevronLeft className={`w-4 h-4 ${t.muted}`} /></div>
      <div className={`text-sm mt-3 ${t.muted}`}>{l}</div>
      <div className="text-2xl font-black mt-1 ltr text-right" style={{ fontFamily: "var(--pv-head)" }}>{v}</div>
    </div>
  );
}

function TripsTable({ t }) {
  return (
    <div className={`${t.card} overflow-hidden`}>
      <div className="flex items-center justify-between p-4"><b style={{ fontFamily: "var(--pv-head)" }}>آخر النقلات</b><span className={`text-sm ${t.muted}`}>عرض الكل</span></div>
      <div className="overflow-x-auto"><table className="w-full text-sm text-right"><thead><tr className={t.tableHead}>{["رقم النقلة", "النوع", "السائق", "السيارة المنقولة", "المبلغ", "الدفع"].map((h) => <th key={h} className="p-3 font-bold whitespace-nowrap">{h}</th>)}</tr></thead>
        <tbody>{TRIPS.map(([n, ty, d, a, p, m, st, c]) => <tr key={n} className={`border-t ${t.row}`}><td className="p-3 ltr text-right font-bold">{n}</td><td className="p-3">{ty}</td><td className="p-3">{d}</td>
          <td className="p-3"><Plate t={t} adm={a} plate={p} /></td><td className="p-3 ltr text-right">{m}</td><td className="p-3"><span className="px-2.5 py-1 rounded-full text-xs font-bold" style={t.pill(TONES[c])}>{st}</span></td></tr>)}</tbody></table></div>
    </div>
  );
}

export default function AdminMock({ t }) {
  return (
    <div className={`flex rounded-3xl overflow-hidden border border-black/10 min-h-[640px] ${t.page}`} data-testid={`preview-admin-${t.id}`}>
      <Sidebar t={t} />
      <div className="flex-1 min-w-0">
        <div className={`flex items-center gap-3 px-5 py-3 ${t.header}`}>
          <div className={`flex-1 flex items-center gap-2 px-3 py-2 text-sm ${t.btnGhost}`}><Search className="w-4 h-4 opacity-60" /><span className="opacity-60">بحث سريع: سائق، لوحة، نقلة...</span></div>
          <button className={`px-4 py-2 text-sm flex items-center gap-1 ${t.btn}`}><Plus className="w-4 h-4" />إضافة</button>
        </div>
        <div className="p-5 space-y-5">
          <div><h2 className="text-2xl font-black" style={{ fontFamily: "var(--pv-head)" }}>لوحة التحكم</h2><p className={`text-sm ${t.muted}`}>ملخص اليوم — الأحد 25 أكتوبر</p></div>
          <div className="grid grid-cols-2 xl:grid-cols-4 gap-3">{STATS.map((s) => <StatCard key={s[1]} t={t} s={s} />)}</div>
          <TripsTable t={t} />
        </div>
      </div>
    </div>
  );
}
